<template>
  <div class="corpo-payment-form">
    <h3 class="header">{{ $t('components.corpo_payment_step.form_title') }}</h3>
    <payment-form-v2 ref="corpoPaymentForm" @readyToPay="(val) => (isReadyToPay = val)" :has-payment-methods="false" :order-type="OrderType.CORPORATE" @submit="enterSubmit" />
    <hello-form-error />

    <div class="btn-container">
      <h-btn @click="pay" :loading="working" block :disabled="!hasAContextAndContextIsReady || !isReadyToPay">{{ $t('components.corpo_payment_step.proceed_text') }}</h-btn>
    </div>
    <corpo-promotion-sold-out-modal v-model="showPromotionSoldOutModal" @reset="reset" @goto="goto"></corpo-promotion-sold-out-modal>
    <corpo-promotion-out-of-inventory-modal v-model="showPromotionOutOfInventoryAmount" @reset="reset" @goto="goto"></corpo-promotion-out-of-inventory-modal>
    <corpo-offer-terms-and-conditions-modal></corpo-offer-terms-and-conditions-modal>
  </div>
</template>

<script>
import PaymentFormV2 from '@/components/pay-and-get/components/PaymentFormV2';
import CorpoOfferTermsAndConditionsModal from '@/components/corpo/order-process/CorpoOfferTermsAndConditionsModal.vue';
import CorpoPromotionSoldOutModal from '@/components/corpo/order-process/CorpoPromotionSoldOutModal.vue';
import CorpoPromotionOutOfInventoryModal from '@/components/corpo/order-process/CorpoPromotionOutOfInventoryModal.vue';
import safeExecute from '@/composables/safe-execute';
import { mapGetters } from 'vuex';
import { recaptcha } from '@/mixins';
import OrderType from '@/utils/order-type';

export default {
  name: 'corpo-payment-form',
  props: {},
  setup(props, { root }) {
    const { executeForm, working } = safeExecute(root.$store);
    return {
      executeForm,
      working,
    };
  },
  data() {
    return {
      OrderType,
      isReadyToPay: false,
      showPromotionSoldOutModal: false,
      showPromotionOutOfInventoryAmount: false,
    };
  },
  mixins: [recaptcha],
  components: {
    PaymentFormV2,
    CorpoPromotionSoldOutModal,
    CorpoOfferTermsAndConditionsModal,
    CorpoPromotionOutOfInventoryModal,
  },
  computed: {
    ...mapGetters('account', ['accountId']),
    ...mapGetters('ui', ['currentLocale']),
    ...mapGetters('corpo', ['hasAContextAndContextIsReady', 'contextTotal']),
    ...mapGetters('tracking', ['trackingLinkId', 'visitorUuid']),
  },
  methods: {
    goto(location) {
      this.$emit('goto', location);
    },
    reset() {
      this.$emit('reset');
    },
    async enterSubmit() {
      if (this.hasAContextAndContextIsReady && this.isReadyToPay) {
        this.pay();
      }
    },
    async pay() {
      const _this = this;
      const payload = {};

      if (this.trackingLinkId && this.visitorUuid) {
        payload.tracking_link_id = this.trackingLinkId;
        payload.visitor_uuid = this.visitorUuid;
      }
      await this.executeForm(
        {
          beforeAction: async () => {
            payload.recaptcha_token = await this.recaptcha('corpoPayment');
            const { token, merchantRefNum, postal_code } = await this.$refs.corpoPaymentForm.submit(this.contextTotal);
            payload.payment_method_token = token;
            payload.merchant_ref_number = merchantRefNum;
            payload.postal_code = postal_code;
          },
          name: 'pay',
          action: 'corpo/pay',
          afterError: (err) => {
            if (err.code === 'errors.http.offer_promotion_status_not_available') {
              this.showPromotionSoldOutModal = true;
            }
            if (err.code === 'errors.http.amount_out_of_inventory_available_amount') {
              this.showPromotionOutOfInventoryAmount = true;
            }
          },
          success: () => {
            _this.$emit('next');
          },
        },
        payload,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-container {
  margin: var(--gap) 0;
  text-align: center;
}
</style>
